import React, { ReactNode } from 'react';

export default function Footer({ children }: { children: ReactNode | ReactNode[] }) {
  return <div className="t-card__footer">{children}</div>;
}
